import {DBConfig} from "ngx-indexed-db";

export const dbConfig: DBConfig = {
  name: 'CacheDatabase',
  version: 1,
  objectStoresMeta: [
    {
      store: 'fleet_api_cache', // Nome del database per la cache
      storeConfig: {keyPath: 'url', autoIncrement: false},
      storeSchema: [
        {name: 'url', keypath: 'url', options: {unique: true}}, // Il contenuto della risposta
        {name: 'response', keypath: 'response', options: {unique: false}}, // Il contenuto della risposta
        {name: 'responseTime', keypath: 'responseTime', options: {unique: false}} // Data e ora della cache
      ]
    }
  ]
};
